import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem("userAccessToken");
  return {
    Authorization: `Bearer ${token}`,
  };
};

// Get dashboard analytics
export const getDashboardAnalytics = async (days = 7) => {
  return axios.get(`${API_BASE}/api/dashboard/analytics`, {
    params: { days },
    headers: getAuthHeaders(),
  });
};

